import React, { useEffect, useContext, useRef } from "react";
import { accountService } from "../../services/accountService";
import LogicContext from "../../Context/LogicContext";
import { SetWalletTransAtom,GetWalletTransAtom} from "../../store/walletTransAtom";
// import CurrencyFormat from 'react-currency-format';
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { useState } from "react";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { useLocation, useNavigate } from "react-router-dom";

import { IoMdRefresh } from "react-icons/io";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { useForm } from "react-hook-form";
import moment from "moment";
import { formatCustomDate } from "../../helpers/formatCustomDate";
import { walletTransService } from "../../services/walletTransService";
import WalletTransFilter from "./WalletTransFilter";


const columns = [
  {
    title: 'Reference',
    key: 'ref_no',
    dataIndex: 'ref_no',
  sorter: (a, b) => (a?.ref_no ?? '') - (b?.ref_no ?? '')
  },

  {
    title: 'Date',
    dataIndex: 'transaction_date',
//   className: "text-primary font-bold",
  sorter: (a, b) => (a?.transaction_date ?? '').localeCompare(b?.transaction_date ?? ''),
  render: (record) => <span> {formatCustomDate(record)} </span>

  },
    

  {
    title: "Customer Name",
    dataIndex: "customer_full_name",
    sorter: (a, b) => (a?.customer_full_name ?? '').localeCompare(b?.customer_full_name ?? '')
  },

  {
    title: "Email",
    dataIndex: "customer_email_address",
    sorter: (a, b) => (a?.customer_email_address ?? '').localeCompare(b?.customer_email_address ?? '')
  },
  {
    title: "Customer Mobile",
    dataIndex: "customer_mobile_no",
    sorter: (a, b) => (a?.customer_mobile_no ?? '').localeCompare(b?.customer_mobile_no ?? '')
  },

  {
    title: "Type",
    dataIndex: "transaction_type_name",
    sorter: (a, b) => (a?.transaction_type_name ?? '').localeCompare(b?.transaction_type_name ?? '')
  },

  {
    title: "Amount",
    dataIndex: "amount",
    sorter: (a, b) => (a?.ref_no ?? '') - (b?.ref_no ?? ''),
    render: (record) => <span> {formatCustomNumber(record)} </span>

  },

  {
    title: "Naration",
    dataIndex: "narration",
  sorter: (a, b) => (a?.narration ?? '') - (b?.narration ?? '')
  },

 
];


function WalletTransMainPage() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const logicContext = useContext(LogicContext);
 
  const myPromiseModal = createModal(GeneralModal);

  const setWalletAtom = SetWalletTransAtom();
  const walletAtomData = GetWalletTransAtom();
  const [tableData, setTableData] = useState([]);
  const [itemSelected, setItemSelected] = useState([]);
  const paymentModeIdRef = useRef(null);
  const depositToRef = useRef(null);
  const isMounted = useRef(false);
  const [searchText, setSearchText] = useState("");
      const {   register,  setValue,  getValues,   handleSubmit,  reset, formState: { errors }  } = useForm();




  useEffect(() => {
    document.title = "Wallet Transactions"

    isMounted.current = true;
    if(!walletAtomData?.wallet_transaction?.length){
       getWalletListApi();

    }else{
      setTableData(walletAtomData?.wallet_transaction);
    }

    return () => {
      isMounted.current = false;
      paymentModeIdRef.current = null;
      depositToRef.current = null; 
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletAtomData?.wallet_transaction?.length]);



// For reload after adding nre data
  useEffect(()=> {
    if (sessionStorage.getItem("reloadPage") === "true") {
      sessionStorage.removeItem("reloadPage");
      getWalletListApi();
    }

  },[]);


 




  const getWalletListApi = async () => {
    try {
      const response = await walletTransService.walletTransList();
      if (response?.data?.transaction_type?.length) {
        setTableData(response?.data?.wallet_transaction);
        setWalletAtom(response.data);
    
      }
    } catch (error) {
      logicContext.showToast("connection error getting invoice data", "error");
    }
  };



  function selectedTableItems(itemList) {
    setItemSelected(itemList);
  }


  function addNewWalletTransaction() {
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`
    );
  }

  const onFilterSelect = (sel) => {
    const transaction_type_id = sel?.transaction_type_id;
    if(transaction_type_id === 0){
      return setTableData(walletAtomData?.wallet_transaction);
    }
    console.log("sel ", sel);
    const newList = walletAtomData?.wallet_transaction.filter((trans)=>trans.transaction_type_id === transaction_type_id );
    setTableData(newList);
  }



  const paginationOptions = {
    pageSize: 10,
    showSizeChanger: true,
    total: tableData.length,
  };



  function handleRowClick(payment) {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${payment?.ref_no}`);
  }



          const searchByDate = async (event) => {
            const formData = getValues();
            const response = await walletTransService.walletTransByDate(formData);
            if (response?.data?.length) {
              setTableData(response?.data);
            } else {
              logicContext.showToast("No result found", "");
              setTableData([]);
            }
          };


          // 1️⃣ define a filter function
          const handleSearch = (text) => {
            setSearchText(text);
          
            if (text.trim() === "") {
              setTableData(walletAtomData?.wallet_transaction || []);
              return;
            }
          
            const searchTerm = text.toLowerCase();
            const filtered = (walletAtomData?.wallet_transaction || []).filter(transaction =>
              Object.values(transaction).some(value => 
                value?.toString().toLowerCase().includes(searchTerm)
              )
            );
            
            setTableData(filtered);
          };
      

  return (
    <>
<section className="flex flex-col space-y-4 ">
  {/* Top: Filter, Date Search, and Reload */}
  <div className="md:flex items-center justify-between space-y-4 md:space-y-0">
    {/* Left side: Filter + Reload */}
    <div className="flex items-center space-x-2">
      <WalletTransFilter
        list={walletAtomData?.transaction_type}
        onFilterSelect={onFilterSelect}
      />
      <Tooltip title="Reload">
        <div
          onClick={() => getWalletListApi()}
          className="h-fit w-fit p-2 rounded-full cursor-pointer hover:bg-gray-200 active:bg-gray-300"
        >
          <IoMdRefresh className="h-[20px] w-[20px] text-gray-600" />
        </div>
      </Tooltip>
    </div>

    {/* Middle: Date Search */}
    <div className="flex flex-row items-end space-x-2">
      <div>
        <span className="ml-1 text-sm">From Date:</span>
        <input
          defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
          {...register("from_date")}
          className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
          type="date"
        />
      </div>
      <div>
        <span className="ml-1 text-sm">To Date:</span>
        <input
          {...register("to_date")}
          defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
          className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
          type="date"
        />
      </div>
      <div>
        <button
          onClick={() => searchByDate()}
          type="button"
          className="text-sm text-white px-3 bg-blue-500 rounded py-2.5"
        >
          Search
        </button>
      </div>
    </div>
  </div>

  {/* Bottom: Text Search, Centered */}
  <div className="flex justify-center mt-2">
    <div className="flex flex-col w-full md:w-1/3">
      <span className="ml-1 text-sm">Search:</span>
      <input
        type="text"
        placeholder="Search in table"
        value={searchText}
        onChange={(e) => handleSearch(e.target.value)}
        className="bg-white ring-1 ring-gray-200 w-full pl-3 py-2 rounded outline-none focus:ring-blue-300"
      />
    </div>
  </div>
</section>



       
        <section className="mt-5">
            <GeneralCustomTable
                  tableHeadList={columns} 
                  tableDataList={tableData}
                allowCheckBox={false} // show checkBox for each row
                setSelectedRows={selectedTableItems}
                paginationOptions={paginationOptions} 
                rowKey={(record) => record.Payment_Ref_No} // custom key
                handleRowClick={handleRowClick} />
            </section>
    </>
  );
}

export default WalletTransMainPage;
